import React from 'react'
import { Flex, Button } from '@chakra-ui/react'
import { ContainerHeading } from '../Headings'
import { NoDataFound } from '../Misc/NoDataFound'
import SubscriptionList from '../Subscriptions/SubscriptionsList'
import { Maybe, UserProperty } from '../../generated/graphql'
import { useNavigate } from 'react-router-dom'

type PropertiesListType = {
  userProperties: UserProperty[]
  onboardingStepsCompleted: Maybe<number> | undefined
}

const PropertiesListContainer: React.FC<PropertiesListType> = ({
  userProperties,
  onboardingStepsCompleted
}) => {
  const navigate = useNavigate()
  const canAddProperty = onboardingStepsCompleted && onboardingStepsCompleted >= 9 ? false : true
  return (
    <Flex
      direction={'column'}
      w="100%"
      bg="#ffff"
      gap="25px"
      rounded={'6px'}
      p={'25px'}
      shadow="md"
    >
      <Flex w="full">
        <ContainerHeading title="Properties" />
        <Button
          variant={'dark'}
          onClick={() => navigate('/user/new-subscription')}
          isDisabled={canAddProperty}
        >
          Add new
        </Button>
      </Flex>
      {userProperties.length <= 0 ? (
        <NoDataFound />
      ) : (
        <SubscriptionList
          subscriptions={userProperties}
          onboardingStepsCompleted={onboardingStepsCompleted}
        />
      )}
    </Flex>
  )
}

export default PropertiesListContainer
